import React, { useEffect, useState } from 'react';
import { getRequest, postRequest } from '../../../Utils/AppApi';
import { DMT_SETTING_URL } from './../../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { Button, Select, Switch } from 'antd';

function DmtSetting(props) {
    const history = useHistory();
    const [getData, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [savingIndex, setSavingIndex] = useState(null);

    const bankOption = [
        { value: 'bank1', label: 'Bank 1' },
        { value: 'bank2', label: 'Bank 2' },
        { value: 'bank3', label: 'Bank 3' }
    ];

    const handleBankChange = (value, index) => {
        const updatedData = [...getData];
        updatedData[index].pipe = value;
        setData(updatedData);
    };

    const onChangeValue = (event, index) => {
        const { name, value } = event.target;
        const updatedData = [...getData];
        updatedData[index][name] = value;
        setData(updatedData);
    }

    const handleSubmit = (index) => {
        setSavingIndex(index);
        postRequest(DMT_SETTING_URL, getData[index]).then((response) => {
            if (response.success === true) {
                toast.success(response.message || 'Settings saved');
            } else {
                toast.error(response.message);
            }
        }).catch(function (error) {
            console.log(error);
            toast.error('Failed to save');
        }).finally(() => {
            setSavingIndex(null);
        });
    }

    const getAppData = () => {
        setLoading(true);
        getRequest(DMT_SETTING_URL, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
            }
        }).catch(function (error) {
            console.log(error);
            toast.error('Failed to load settings');
        }).finally(() => {
            setLoading(false);
        });
    }

    const onChangeSwitch = (checked, index) => {
        const updatedData = [...getData];
        updatedData[index].flag = checked;
        setData(updatedData);
    };

    useEffect(() => {
        getAppData();
    }, []);

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '200px' 
            }}>
                Loading DMT settings...
            </div>
        );
    }

    return (
        <div style={{
            background: '#f8fafc',
            minHeight: '100vh',
            padding: '20px'
        }}>
            {/* Header similar to AppInfo */}
            <div style={{
                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                color: 'white'
            }}>
                <h1 style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: '600', 
                    margin: '0 0 8px 0',
                    color: 'white'
                }}>
                    DMT Settings
                </h1>
                <p className="app-info-main-subtitle">
                    Configure DMT service parameters and bank integrations
                </p>
            </div>

            {/* Settings Table */}
            <div style={{
                background: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                border: '1px solid #e5e7eb'
            }}>
                <table style={{ 
                    width: '100%', 
                    borderCollapse: 'collapse',
                    fontSize: '0.875rem'
                }}>
                    <thead>
                        <tr style={{ 
                            borderBottom: '2px solid #e5e7eb',
                            textAlign: 'left'
                        }}>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Name</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Code</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Bank</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Status</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Pipe</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Message</th>
                            <th style={{ padding: '12px 16px', color: '#374151', fontWeight: '600' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getData.map((item, index) => (
                            <tr key={index} style={{ 
                                borderBottom: '1px solid #f3f4f6',
                                transition: 'background 0.2s'
                            }}>
                                <td style={{ padding: '16px', color: '#111827', fontWeight: '500' }}>
                                    {item.name}
                                </td>
                                <td style={{ padding: '16px', color: '#6b7280', fontSize: '0.8125rem' }}>
                                    {item.code}
                                </td>
                                {/* New Bank column */}
                                <td style={{ padding: '16px', color: '#6b7280', fontSize: '0.8125rem' }}>
                                    {item.bank}
                                </td>
                                <td style={{ padding: '16px' }}>
                                    <Switch
                                        checked={item.flag}
                                        onChange={(e) => onChangeSwitch(e, index)}
                                        style={{ backgroundColor: item.flag ? '#10b981' : '#d1d5db' }}
                                    />
                                </td>
                                <td style={{ padding: '16px' }}>
                                    {item.code === "DMT2" ? 
                                        <Select
                                            value={item.pipe}
                                            onChange={(e) => handleBankChange(e, index)}
                                            options={bankOption}
                                            style={{ width: '120px' }}
                                            size="small"
                                        />
                                        : 
                                        <input
                                            type="text"
                                            style={{
                                                padding: '6px 12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '6px',
                                                fontSize: '0.875rem',
                                                width: '120px'
                                            }}
                                            name="pipe"
                                            onChange={(e) => onChangeValue(e, index)}
                                            value={item.pipe || ''}
                                            placeholder="Pipe"
                                        />
                                    }
                                </td>
                                <td style={{ padding: '16px' }}>
                                    <input
                                        type="text"
                                        style={{
                                            padding: '6px 12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '6px',
                                            fontSize: '0.875rem',
                                            width: '100%'
                                        }}
                                        name="message"
                                        onChange={(e) => onChangeValue(e, index)}
                                        value={item.message || ''}
                                        placeholder="Message"
                                    />
                                </td>
                                <td style={{ padding: '16px' }}>
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={() => handleSubmit(index)}
                                        loading={savingIndex === index}
                                        style={{
                                            background: '#3b82f6',
                                            border: 'none',
                                            padding: '4px 12px',
                                            fontSize: '0.75rem',
                                            height: '28px'
                                        }}
                                    >
                                        Save
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Info footer similar to AppInfo */}
            <div style={{
                marginTop: '20px',
                padding: '16px',
                background: '#fefce8',
                border: '1px solid #fde68a',
                borderRadius: '8px',
                fontSize: '0.875rem',
                color: '#92400e',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}>
                <span>ℹ️</span>
                <span>Save changes individually for each DMT service. Changes take effect immediately.</span>
            </div>
        </div>
    );
}

export default DmtSetting;